document.addEventListener('DOMContentLoaded', () => {

    function fadeInPage() {

        const fader = document.querySelector('.loading-animation');

        const hasVisited = getCookie('hasVisited');
        if (!hasVisited) {
            fader.classList.add('loading-animation__first');
            setCookie('hasVisited', 'true', 365);
        }

        const hideFader = () => {
            fader.style.display = 'none';
            fader.classList.remove('loading-animation__fade-out');
            fader.classList.remove('loading-animation__fade-in');

            // After hiding the fader, handle scrolling to the anchor if present
            if (window.location.hash) {
                const targetId = window.location.hash.substring(1);
                const targetElement = document.getElementById(targetId);
                if (targetElement) {
                    // Use a slight delay to ensure the browser has completed its default scroll
                    setTimeout(() => {
                        targetElement.scrollIntoView({ behavior: 'auto' });
                    }, 0);
                }
            }
        };

        fader.classList.add('loading-animation__fade-out');
        fader.addEventListener('animationend', hideFader, { once: true });

        const anchors = document.querySelectorAll('a[href^="#"]'); // Select only internal anchors
        anchors.forEach((anchor) => {
            if (anchor.hostname !== window.location.hostname) return;

            const handleClickOrTouch = function (event) {
                const anchorUrl = anchor.href.split('#')[0];
                const targetId = anchor.getAttribute('href').substring(1);
                const targetElement = document.getElementById(targetId);

                // Check if the link is to an anchor on the same page
                if (anchorUrl === window.location.href.split('#')[0] && targetElement) {
                    event.preventDefault(); // Prevent default anchor behavior
                    targetElement.scrollIntoView({ behavior: 'auto' }); // Scroll to target without smooth behavior
                } else {
                    fader.style.display = 'flex';
                    fader.classList.remove('loading-animation__fade-out');
                    fader.classList.add('loading-animation__fade-in');
                    window.location = anchor.href;
                }
            };

            anchor.addEventListener('click', handleClickOrTouch);
            anchor.addEventListener('touchstart', handleClickOrTouch, { passive: true });
        });

        window.addEventListener('pageshow', function (event) {
            if (!event.persisted) return;
            fader.style.display = 'flex';
            fader.classList.add('loading-animation__fade-out');
            fader.addEventListener('animationend', hideFader, { once: true });
        });
    }

    function setCookie(name, value, days) {
        const expires = new Date(Date.now() + days * 864e5).toUTCString(); // days to milliseconds
        document.cookie =
            name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=/';
    }

    function getCookie(name) {
        return document.cookie.split('; ').reduce((r, v) => {
            const parts = v.split('=');
            return parts[0] === name ? decodeURIComponent(parts[1]) : r;
        }, '');
    }

    fadeInPage();
});
